import React, {useEffect, useLayoutEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import {useLinkNavigate, useSplitPath} from 'helpers/hooks/links';
import {useProfile} from 'components/organisms/Providers/ProfileProvider/ProfileProvider';
import StyledDealflowEntitySideBarWrapper
  from 'components/templates/Wrappers/Dealflow/Entities/DealflowEntitySideBarWrapper/DealflowEntitySideBarWrapper.styles';
import DealflowEntitiesList from 'components/organisms/Lists/DealflowEntitiesList/DealflowEntitiesList';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';

const DealflowEntitySideBarWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    anchor: 'left',
    ...props
  }, 'DealflowEntitySideBarWrapper');

  const tableProvider = useTable();
  const profileProvider = useProfile();

  const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const [open, setOpen] = useState(!lgDown);
  const [animate, setAnimate] = useState(false);
  const [initialised, setInitialised] = useState(false);

  const navigate = useLinkNavigate();

  const [pathPrefix, pathPostfix] = useSplitPath('dealflow');
  const pathPostSplit = pathPostfix.split('/');
  const postFix = pathPostSplit.length > 1 ? `/${pathPostSplit.slice(1).join('/')}` : '';
  const pathKey = pathPostSplit[1] ?? 'profile';

  const pathEntityId = pathPostSplit[0];
  const selectedEntityId = tableProvider.selected()?.entityId;
  const entityLoaded = +selectedEntityId === +pathEntityId;

  const handleClick = (e, entity) => {
    navigate({
      event: e,
      to: `${pathPrefix}/${entity.entityId}${postFix}`,
      keepSearchParams: true
    });
  };

  useEffect(() => {
    setInitialised((current) => {
      return current || entityLoaded
    });
  }, [entityLoaded]);

  useLayoutEffect(() => {
    setAnimate(false);
  }, [pathKey]);

  useEffect(() => {
    setAnimate(true);
  }, [pathKey]);

  const handleContextToggle = (e, open) => {
    setOpen(open);
  }

  useLayoutEffect(() => {
    setOpen(!lgDown);
  }, [lgDown]);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledDealflowEntitySideBarWrapper ref={ref} {...innerProps}
                                             variant={lgDown ? 'temporary' : 'standard'}
                                             context={<DealflowEntitiesList onClick={initialised ? handleClick : null}/>}
                                             open={open && Boolean(profileProvider.state?.showSidebar?.[pathKey])}
                                             animate={animate}
                                             onToggle={handleContextToggle}
                                             size="small"/>
});

DealflowEntitySideBarWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowEntitySideBarWrapper;
